import {
  Alert,
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TourPurchaseGuestsInfo } from '../pages/TourPurchase';
import { ContactForm, ContactFormValues } from './ContactForm';

export function TourPurchaseContactInfo(props: {
  guestsInfo: TourPurchaseGuestsInfo;
  sharedContactInfo: ContactFormValues;
  setSharedContactInfo: (data: ContactFormValues) => Promise<void>;
  setGuestContactInfoChange: (
    id: number,
    value: { differentContactInfo: boolean; contact?: ContactFormValues },
  ) => Promise<void>;
  errors: { [key: string]: string | undefined };
}) {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography sx={{ mb: 2, color: 'text.secondary' }}>
        {t('tourPurchaseContactInfo.note')}
      </Typography>
      {!props.guestsInfo.adults
        .concat(props.guestsInfo.children)
        .every((g) => g.differentContactInfo) && (
        <ContactForm
          initialValues={props.sharedContactInfo}
          onSubmit={async (data) => {
            props.setSharedContactInfo(data);
          }}
        />
      )}
      <Divider sx={{ my: 3 }} />
      <Stack spacing={1} sx={{ mt: 2 }}>
        {props.guestsInfo.adults.length > 1 &&
          props.guestsInfo.adults.map((g, i) => (
            <Box
              key={g.id}
              sx={
                g.differentContactInfo
                  ? {
                      p: 2,
                      border: (t) => `1px solid ${t.palette.divider}`,
                      borderRadius: 1,
                      my: 1,
                    }
                  : {}
              }
            >
              <Typography>
                {t('tourPurchaseContactInfo.adultNth', {
                  n: i + 1,
                  name: g.firstName + ' ' + g.lastName,
                })}
              </Typography>
              <FormControlLabel
                control={<Checkbox />}
                label={t('tourPurchaseContactInfo.differentContactInfo')}
                checked={g.differentContactInfo}
                onChange={(e, v) => {
                  props.setGuestContactInfoChange(g.id as number, {
                    differentContactInfo: v,
                    contact: undefined,
                  });
                }}
              />
              {g.id && props.errors[g.id] && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {props.errors[g.id]}
                </Alert>
              )}
              {g.differentContactInfo && (
                <Box sx={{ mt: 2 }}>
                  <ContactForm
                    initialValues={g.contact || props.sharedContactInfo}
                    onSubmit={(data) => {
                      props.setGuestContactInfoChange(g.id as number, {
                        differentContactInfo: true,
                        contact: data,
                      });
                    }}
                  />
                </Box>
              )}
            </Box>
          ))}
        {props.guestsInfo.adults.length > 1 &&
          props.guestsInfo.children.map((g, i) => (
            <Box key={g.id}>
              <Typography>
                {t('tourPurchaseContactInfo.childNthhildNth', {
                  n: i + 1,
                  name: g.firstName + ' ' + g.lastName,
                })}
              </Typography>
              <FormControlLabel
                control={<Checkbox />}
                label={t('tourPurchaseContactInfo.differentContactInfo')}
                checked={g.differentContactInfo}
                onChange={(e, v) => {
                  props.setGuestContactInfoChange(g.id as number, {
                    differentContactInfo: v,
                    contact: undefined,
                  });
                }}
              />
              {g.id && props.errors[g.id] && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {props.errors[g.id]}
                </Alert>
              )}
              {g.differentContactInfo && (
                <Box sx={{ mt: 2 }}>
                  <ContactForm
                    initialValues={g.contact || props.sharedContactInfo}
                    onSubmit={(data) => {
                      props.setGuestContactInfoChange(g.id as number, {
                        differentContactInfo: true,
                        contact: data,
                      });
                    }}
                  />
                </Box>
              )}
            </Box>
          ))}
      </Stack>
    </Box>
  );
}
